import * as React from "react";

export interface HeaderProps {
  title: string;
  logo: string;
  message: string;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, logo, message } = props;

  return (
    <header className="bg-slate-900 text-white">
      <div className="mx-auto flex max-w-5xl items-center gap-4 px-6 py-10">
        <img
          className="h-16 w-16 rounded-lg bg-white/10 p-2 object-contain"
          src={logo}
          alt={title}
        />
        <div>
          <p className="text-sm uppercase tracking-widest text-slate-200">{title}</p>
          <h1 className="text-3xl font-semibold tracking-tight">{message}</h1>
        </div>
      </div>
    </header>
  );
};

export default Header;
